import { getInputType, PropertyTypes } from "@ext/properties/models";

const getDisplayValue = (type: PropertyTypes, value: string[] | string) => {
	if (!getInputType[type]) return Array.isArray(value) ? value.join(", ") : value;

	if (type === PropertyTypes.date) {
		const date = value?.[0];
		if (!date) return "";
		return new Date(date).toLocaleDateString();
	}

	return Array.isArray(value) ? value.join(", ") : value;
};

export default getDisplayValue;
